export const formatDateWithLocale = (isoDateString: string, lang: string) => {
    const date = new Date(isoDateString);
    return new Intl.DateTimeFormat(lang, {
        day: '2-digit',
        month: 'short',
        year: '2-digit',
    })
        .format(date)
        .replace('.', '');
};
